import {
  InstructionButtonActions,
  InstructionButtonActionTypes,
  InstructionButtonState,
} from './types';

export const defaultState = (): InstructionButtonState => ({
  currentInstruction: undefined,
  instructionButtonDisabled: false,
  playInstructionFlag: false,
});

export const reducers = (
  state: InstructionButtonState,
  action: InstructionButtonActions
): InstructionButtonState => {
  switch (action.type) {
    case InstructionButtonActionTypes.SET_PLAY_FLAG:
      return { ...state, ...{ playInstructionFlag: action.payload } };
    case InstructionButtonActionTypes.SET_DISABLED:
      return { ...state, ...{ instructionButtonDisabled: action.payload } };
    case InstructionButtonActionTypes.SET_CURRENT_INSTRUCTION:
      return { ...state, ...{ currentInstruction: action.payload } };
    default:
      return { ...state };
  }
};
